import { useNavigate, useParams } from "react-router-dom";
import styles from "./style.module.css"
import { Categories } from "../../marketPlace/components/categories";
import { GridContainer } from "../../components/GridContainer";
import { StoreDetailsCard } from "../../marketPlace/components/storeDetailsCard";
import { bestDeals } from "../../lib/constants";
import { Explore } from "../../components/ExploreComponent";
import { FilterSidebar, FilterGroupData, FilterValues, } from "../../components/FilterSideBar";
import { useEffect, useState } from "react";
import FlatButtons from "../../components/FlatButton/FlatButton";
import Typography from "../../components/Typography/Typography";
import { filter } from "../../assets/svgs";

type FilterNames =
    | "Color"
    | "Price"
    | "Featured"
    | "Occasion"
    | "Material"
    | "Brand";

export const MarketPlaceStores = () => {

    const [showFilter, setShowFilter] = useState(false)
    const [filters, setFilters] = useState<FilterValues<FilterNames>>({});

    const { item } = useParams<{ item: string }>();
    console.log(item)
    const navigate = useNavigate()


    const filterData: FilterGroupData<FilterNames>[] = [
        { title: "Color", type: "color", colors: ["#000000", "#9CA3AF", "#F3F4F6", "#0C1A4B"] },
        { title: "Price", type: "range", range: [300, 7000] },
        { title: "Featured", type: "checkbox", options: ["New Arrival", "Best Sellers"] },
        { title: "Occasion", type: "checkbox", options: ["Casual", "Party", "Office", "Vacation"] },
        { title: "Material", type: "checkbox", options: ["Cotton", "Silk", "Satin", "Denim"] },
        { title: "Brand", type: "checkbox", options: ["Local", "Imported"] },
    ];

    useEffect(() => {
        if (Object.keys(filters).length > 0) {
            console.log("Selected filters:", filters);
        }
    }, [filters]);

    return (
        <div className={styles.container}>
            <Categories />
            <Explore item={item ?? ""} />
            <div className={styles.subContainer}>
                <div className={`${styles.filterContainer} ${styles.hide}`}>
                    <FilterSidebar<FilterNames> filters={filterData} onChange={setFilters} />
                </div>
                <div className={styles.cardContainer}>

                    <div className={styles.mobileViewFilterContainer}>

                        <div className={styles.filterBtn}>
                            <FlatButtons
                                onClick={() => {
                                    setShowFilter(!showFilter)
                                }}
                                className={styles.primaryButton}
                            >
                                <img src={filter} alt="" />
                                <Typography
                                    variant="buttonText"
                                    fontFamily="satoshi"
                                    weight="regular"
                                    size="base"
                                    className={styles.primaryButtonText}
                                >
                                    Filter
                                </Typography>
                            </FlatButtons>
                        </div>
                        <div className={`${showFilter ? styles.filterContainerMobile : styles.hideFilter}`}>
                            {showFilter && (<FilterSidebar<FilterNames> filters={filterData} onChange={setFilters} />)}
                        </div>

                    </div>

                    <GridContainer containername={item}>
                        {bestDeals.map((item) => (
                            <StoreDetailsCard
                                storePreview={item.storePreview}
                                storeName={item.storeName}
                                storeRating={item.storeRating}
                                storeCreationDate={item.storeCreationDate}
                                storeItemCount={item.storeItemCount}
                                storeLocation={item.storeLocation}
                                storeId=""
                                storePrice={item.storePrice}
                                onClick={() => {
                                    navigate("/openX")
                                }}
                            />
                        ))}
                    </GridContainer>
                </div>
            </div>
        </div>
    )
}